import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import DashboardC from "../../components/admin/dashboard";

const Dashboard = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <DashboardC />
    </div>
  );
};

export default Dashboard;
